import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-739b1ce2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table stop transition-filter" }
const _hoisted_2 = { class: "frame" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("free "),
  /*#__PURE__*/_createElementVNode("span", null, "🅿️"),
  /*#__PURE__*/_createTextVNode(" parking")
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("go to "),
  /*#__PURE__*/_createElementVNode("span", null, "👮"),
  /*#__PURE__*/_createTextVNode(" jail")
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("in "),
  /*#__PURE__*/_createElementVNode("span", null, "🗝"),
  /*#__PURE__*/_createTextVNode(" jail")
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("em", null, [
    /*#__PURE__*/_createTextVNode("collect "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" £200 salary as you pass")
  ]),
  /*#__PURE__*/_createTextVNode(" go "),
  /*#__PURE__*/_createElementVNode("span", null, "↖️")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, "monopoly", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cards community" }, "community chest", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cards chance" }, "chance", -1))
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "inside" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_18 = { class: "flex justify-around" }
const _hoisted_19 = {
  key: 1,
  class: "inside"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["corner tl", [_ctx.toggleGrayScale ? 'grayout' : '']]),
          style: {"--order":"1"},
          "data-test": "board-item"
        }, _hoisted_4, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["corner tr", [_ctx.toggleGrayScale ? 'grayout' : '']]),
          style: {"--order":"11"},
          "data-test": "board-item"
        }, _hoisted_6, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["corner bl", [_ctx.toggleGrayScale ? 'grayout' : '']]),
          style: {"--order":"31"},
          "data-test": "board-item"
        }, _hoisted_8, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["corner br", [_ctx.toggleGrayScale ? 'grayout' : '']]),
          style: {"--order":"41"},
          "data-test": "board-item"
        }, _hoisted_10, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["center relative", [_ctx.toggleGrayScale ? 'grayout' : '']]),
          style: {"--order":"13"}
        }, _hoisted_14, 2),
        (_ctx.boardData.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.boardData, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass([
              item.pos,
              item.color,
              _ctx.toggleGrayScale ? 'grayout' : '',
              _ctx.includesInArray([14, 11, 3, 19, 10, 16, 13], item.id)
                ? 'no-grayout'
                : '',
            ]),
                style: _normalizeStyle(['--order:' + item.order]),
                "data-test": "board-item",
                onClick: ($event: any) => (
              _ctx.toggleGrayScale ? _ctx.boardClicking(item) : _ctx.showBoardDetail(item)
            )
              }, [
                (item.owner)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("h2", null, _toDisplayString(item.label), 1),
                        _createElementVNode("div", {
                          class: "d-flex py-2",
                          style: _normalizeStyle({ backgroundColor: item.owner.dominateColor })
                        }, [
                          _hoisted_17,
                          _createElementVNode("strong", null, _toDisplayString(_ctx.getCurrentPiecePrice(item)), 1)
                        ], 4)
                      ]),
                      (item.house_count > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["absolute", [`build-slip-${item.pos}`]])
                          }, [
                            _createElementVNode("div", _hoisted_18, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.house_count, (num, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: _normalizeClass([[_ctx.houseLabel[num]], "label-size"])
                                }, null, 2))
                              }), 128))
                            ])
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("h2", null, _toDisplayString(item.label), 1),
                      _hoisted_20,
                      _hoisted_21,
                      _createElementVNode("strong", null, _toDisplayString(item.price), 1)
                    ]))
              ], 14, _hoisted_15))
            }), 128))
          : _createCommentVNode("", true)
      ])
    ]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}